type DefineRoutesOptions = {
  exactKeys?: readonly string[];
};

type IsLowercaseKeyAllowed<Key extends string, Options> =
  Key extends Lowercase<Key>
    ? true
    : Options extends { exactKeys: ReadonlyArray<infer AllowedKeys> }
      ? Key extends AllowedKeys
        ? true
        : false
      : false;

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- any is used to allow for dynamic route construction
type Route = ((...arguments_: any[]) => string) | string;

type StandardResourceRouteKeys = 'create' | 'find' | 'get' | 'patch' | 'remove' | 'update';

type ValidateResourceRoutes<T, Options> = {
  [K in keyof T]: K extends StandardResourceRouteKeys
    ? T[K] extends Route
      ? T[K]
      : never
    : K extends string
      ? IsLowercaseKeyAllowed<K, Options> extends true
        ? T[K] extends Record<string, unknown>
          ? ValidateResourceRoutes<T[K], Options>
          : never
        : never
      : never;
};

export const defineRoutes = <
  const T extends Record<string, unknown>,
  const Options extends DefineRoutesOptions | undefined = undefined,
>(
  routes: T & ValidateResourceRoutes<T, Options>,
  _options?: Options,
): T => routes;
